import LojaModel from "./LojaModel";

export enum ObaTipoPromocaoEnum {
    COMPRE_X_PAGUE_Y = 1,
    DESCONTO,
}

export default class ObaPromocaoModel {
    public id: number = 0;
    public produtos: string[] = [];
    public tipo: ObaTipoPromocaoEnum = ObaTipoPromocaoEnum.COMPRE_X_PAGUE_Y;
    public de: Date = new Date();
    public ate: Date = new Date();
    public lojas: LojaModel[] = [];
    public compre: number = 0;
    public pague: number = 0;
}
